import { uniqBy } from "lodash";

const errorFieldList = {
  general: ["user_name", "first_name", "last_name", "email", "mobile"],
  role: ["main_role", "role"],
  permission: ["user_permission"],
};

export const findErrorField = (errArray = [], formStep) => {
  return errArray.find((ele) => errorFieldList[formStep].includes(ele.name[0]));
};

export const formatMobileNumber = (mobileNum) => {
  if (typeof mobileNum === "string") {
    const numArray = mobileNum.match(/\d/g);
    if (Array.isArray(numArray) && numArray.length >= 10) {
      return `${numArray.slice(0, 3).join("")}-${numArray
        .slice(3, 6)
        .join("")}-${numArray.slice(6, 10).join("")}`;
    }
  }
  return mobileNum;
};

export const userSteps = ({ isAdmin }) => {
  if (isAdmin) {
    return [
      {
        step_id: 0,
        title: "General",
        content: "First-content",
        tag: "general",
      },
      { step_id: 1, title: "Roles", tag: "role" },
      { step_id: 2, title: "SSO Integration", tag: "sso_integration" },
      { step_id: 3, title: "Permissions", tag: "permission" },
      { step_id: 4, title: "Hotels", content: "First-content", tag: "hotel" },
      {
        step_id: 5,
        title: "Activation",
        content: "First-content",
        tag: "activation",
      },
    ];
  }
  return [
    {
      step_id: 0,
      title: "General",
      content: "First-content",
      tag: "general",
    },
    { step_id: 1, title: "Roles", tag: "role" },
    { step_id: 2, title: "Permissions", tag: "permission" },
    { step_id: 3, title: "Hotels", content: "First-content", tag: "hotel" },
    {
      step_id: 4,
      title: "Activation",
      content: "First-content",
      tag: "activation",
    },
  ];
};

export const hotelUserData = (data) => {
  return data.map((el) => ({
    _id: el.hotel_id,
    hotel_name: el.hotel_name,
    hotel_code: el.hotel_code,
    primary_hmg_name: el.hmg_name,
    primary_hmg_project_name: el.project_name,
    secondary_hmg_name: el.secondary_hmg_name,
    secondary_hmg_project_name: el.secondary_project_name,
    third_hmg_name: el.third_hmg_name,
    third_hmg_project_name: el.third_project_name,
    fourth_hmg_name: el.fourth_hmg_name,
    fourth_hmg_project_name: el.fourth_project_name,
    hmg_id: el.hmg_id,
  }));
};

export const preprocessHmgData = (data) => {
  return uniqBy(
    data.map((el) => ({
      _id: el.hmg_id,
      hmg_name: el.hmg_name,
    })),
    "_id",
  ).sort((a, b) =>
    a?.hmg_name?.toLowerCase().localeCompare(b?.hmg_name?.toLowerCase()),
  );
};

export const preprocessProjectData = (data) => {
  return uniqBy(
    data.map((el) => ({
      _id: el.project_id,
      hmg_id: el.hmg_id,
      project_name: el.project_name,
    })),
    "_id",
  );
};

export const APP_LIST = [
  {
    app_name: "Datavision",
  },
  {
    app_name: "IntelliSight Plus",
  },
  {
    app_name: "myPlan",
  },
  {
    app_name: "Workflow Reconciliation",
  },
];
